/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IFooterSectionData } from './footer-section.data';
import { IFooterSectionProps } from './footer-section.props.autogenerated';

export interface IFooterSectionViewProps extends IFooterSectionProps<IFooterSectionData> {}

/**
 *
 * FooterSection component
 * @extends {React.PureComponent<IFooterSectionProps<IFooterSectionData>>}
 */
class FooterSection extends React.PureComponent<IFooterSectionProps<IFooterSectionData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default FooterSection;
